import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/portal/_layout')({
  component: PortalLayout,
});

function PortalLayout() {
  return <Outlet />;
}

